import formatDate from './date-utc';
export * from './date-utc';
export default formatDate;